import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICMS } from "../cmsModel";

export const getAllCMS = createAsyncThunk("CMS/FindAllCMS", async () => {
  try {
    const response = await axiosApiInstance.post(`${API_URL}/CMS/FindAllCMS`, {
      Name: "",
    });
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching CMS:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const getAllActiveCMS = createAsyncThunk(
  "CMS/FindAllActiveCMS",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CMS/FindAllActiveCMS`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCMS = createAsyncThunk(
  "CMS/InsertCMS",
  async (CMSData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/InsertCMS`,
        CMSData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCMS = createAsyncThunk(
  "CMS/UpdateCMS",
  async (CMSData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/UpdateCMS`,
        CMSData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCMSByID = createAsyncThunk(
  "CMS/FindByIDCMS",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/FindByIDCMS`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result.Name,
        URL: result.URL,
        Template: result.Template,
        MetaDescription: result.MetaDescription,
        MetaKeywords: result.MetaKeywords,
        MetaTitle: result.MetaTitle,
        IsActive: result.IsActive ? 1 : 2,
      } as ICMS;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const cmsActiveInactive = createAsyncThunk(
  "CMS/ActiveInActiveCMS",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/ActiveInActiveCMS`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCMS = createAsyncThunk(
  "CMS/DeleteCMS",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(`${API_URL}/CMS/DeleteCMS`, {
        ID,
      });
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
